<style scoped lang="scss">
@import '../assets/style/_mixin.scss';

.login_body {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  background-color: #f5f5f5;
  text-align: center;
}
._brand {
  @include fluid-font-size(24px, 60px);
}
._logo {
  width: 40%;
  height: 40%;
}
.form-signup {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
</style>

<template>
  <div class="login_body">
    <form class="form-signup">
      <img class="_logo" :src="logo">
      <h1 class="h3 mb-3">Sign up</h1>
      <InputFloatLabel
        type="email"
        id="inputEmail"
        name="User Account"
        placeholder="Email address"
        :value.sync="userEmail"
        rule="required|email"
      />
      <InputFloatLabel
        type="password"
        id="inputPassword"
        name="User Password"
        placeholder="Password"
        :value.sync="userPassword"
        rule="required|alpha_num"
      />
      <InputFloatLabel
        type="password"
        id="inputPasswordCheck"
        name="User Password Check"
        placeholder="Check Again Your Password"
        :value.sync="userPasswordCheck"
        :rule="{required: true, is: userPassword}"
      />
      <div class="row">
        <div class="col-4 pr-1">
          <b-button :block="true" variant="outline-primary" to="/sign-in">Sign In</b-button>
        </div>
        <div class="col-8 pl-1">
          <b-button
            block
            variant="primary"
            @click="clickSignUp(userEmail, userPassword)"
            :disabled="signUpFormInvalid"
          >
            Sign Up
          </b-button>
        </div>
      </div>
      <p class="mt-5 mb-3 text-muted">© Intrising Networks, Inc.</p>
    </form>
  </div>
</template>

<script>
import { compact, size } from 'lodash'
import logo from '@/assets/intrising-logo/logo.svg'
import InputFloatLabel from '@/components/InputFloatLabel.vue'
import { signUp } from '@/firebaseRef'

export default {
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  components: {
    InputFloatLabel
  },
  data () {
    return {
      logo,
      userEmail: '',
      userPassword: '',
      userPasswordCheck: ''
    }
  },
  computed: {
    signUpFormInvalid () {
      const suf = [this.userEmail, this.userPassword, this.userPasswordCheck]
      const isInputStrEmpty = compact(suf).length < size(suf) // check if any is ''
      const isInputError = this.errors.any()
      // console.log('signUpFormInvalid', isInputError, this.errors)
      return isInputStrEmpty || isInputError
    }
  },
  methods: {
    clickSignUp (...arg) {
      // validation check
      signUp(...arg)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SignUp.vue